import React, { useEffect, useRef, useState } from 'react';
import { Button, message, Select, Spin, Upload } from 'antd';
import { SDrawer, SFormImagesList, SGeneralForms } from 'shj-components';
import ImageUpload from '@/components/Upload/ImageUpload'
import { saveContractProjectExternalEmployee } from '@/services/externalPerson'
import dayjs from 'dayjs';
import { baseURL } from "@/api";
import { getImgRelativePath } from '@/utils';
import { findProjectExternalEmployeeList } from '@/services/qualityMoneyAccount';
import { useRequest } from 'ahooks';

const ContractAdd = (props: any) => {
  const uploadFileUrl = baseURL + `/file-web/fileStore/upload`;
  const [loading, setLoading] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const formRefs = useRef<any>();
  const [vendorInfoList, setVendorInfoList] = useState<any>([])
  const { visibleDrawer = false, title = '添加线下合同', record, closeDetails, getDetail,contractInfo } = props
  let { loading: queryLoading,runAsync: runAsyncQuery } = useRequest(findProjectExternalEmployeeList, { manual: true });
  useEffect(() => {
    formRefs?.current?.onReset();
    formRefs?.current?.onFormRef().setFieldsValue({});
    if (visibleDrawer) {
      setSpinLoading(true)
      if(contractInfo.id) {
        formRefs?.current?.onFormRef().setFieldsValue({...contractInfo});
      }
    }
    runAsyncQuery({
      data: {
          id: record?.id,
          labelFlag: false
      }
  }).then((res) => {
      setVendorInfoList(res[0]?.vendorInfos || [])
  }).finally(() => {
    setSpinLoading(false)
  })
  }, [visibleDrawer])
  const onSubmit = () => {
    formRefs?.current?.onFormRef()?.validateFields().then(values => {
    values.extEmpId = record.id;
    values.startTime = dayjs(values.contratTime[0]).format('YYYY-MM-DD')
    values.endTime = dayjs(values.contratTime[1]).format('YYYY-MM-DD')
    let formObj = {
      ...values,
      type: "manualContract",
      fileInfolist: values.fileInfolist.map(ev => getImgRelativePath(ev))
    }
    setLoading(true)
    saveContractProjectExternalEmployee(formObj).then((res: any) => {
      message.success(res?.message)
      setLoading(false)
      getDetail()
      closeDetails()
    }).finally(() => {
      setLoading(false)
    })
  })};
  const beforeUpload = (file: any) => {
    if ((file.type || '').startsWith('image') || file.type.endsWith('pdf')|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.endsWith('msword')) {
      if (!file.name.endsWith('.jpg') && !file.name.endsWith('.bmp') && !file.name.endsWith('.png') && !file.name.endsWith('.jpeg') && 
      !file.name.endsWith('.docx') && !file.name.endsWith('.doc') && !file.name.endsWith('.pdf')) {
        message.error('图片必须是jpg/jpeg/png/bmp/doc/docx/pdf格式')
        return Upload.LIST_IGNORE
      }
      return true
    }
    message.error('只能上传图片')
    return Upload.LIST_IGNORE
  }
  // 底部按钮的渲染逻辑
  const footer = contractInfo.id ? null:(
    <>
      <Button onClick={closeDetails} style={{ marginRight: '10px' }}>取消</Button>
      <Button type="primary" onClick={onSubmit}>
          确定
      </Button>
    </>
  )  ;
  return (
    <>
      <SDrawer
        width={1000}
        title={title}
        open={visibleDrawer}
        onClose={closeDetails}
        loading={loading}
        onSubmit={onSubmit}
        footer={footer}
        destroyOnClose
      >
        <Spin spinning={spinLoading}>
          <SGeneralForms
            layout={'vertical'}
            ref={formRefs}
            configs={[{
              title: '合同信息',
              formItem: [
                {
                  name: 'name',
                  label: '合同名称',
                  spanCol: 12,
                  required: true,
                },
                {
                  name: 'code',
                  label: '合同编号',
                  required: true,
                  maxLength: 50,
                  spanCol: 12,
                  rules: [
                    {
                      validator: (_, value) => {
                        if (/[\u4e00-\u9fa5]/.test(value)) {
                          return Promise.reject('合同编号不能包含汉字');
                        }
                        else if(!value) {
                          return Promise.reject('必填');
                        }
                        return Promise.resolve();
                      }
                    }
                  ]
                },
                {
                  name: 'signDate',
                  label: '签订日期',
                  spanCol: 12,
                  required: true,
                  type: 'date',
                },
                {
                  name: 'contratTime',
                  label: '合同周期',
                  spanCol: 12,
                  required: true,
                  type: 'range',
                },
                {
                  name: 'vendorId',
                  label: '承包商',
                  spanCol: 12,
                  children: <Select placeholder={'请选择承包商'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    options={vendorInfoList} showSearch
                  />,
                },
                {
                  name: 'fileInfolist',
                  label: '附件(1-10)',
                  required: true,
                  spanCol: 24,
                  htmlFor: 'fileInfolist',
                  children:
                  contractInfo.id ? <SFormImagesList /> : <ImageUpload limit={10} url={uploadFileUrl} accept={'image/png,image/jpeg,image/jpg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'} beforeUpload={beforeUpload} />,
                },
              ],
            }]}
          />
        </Spin>
      </SDrawer>
    </>
  );
};
export default ContractAdd
